export default "__VITE_ASSET__Ykcx82pk__"